import api from '@/lib/api/axios'
import type { Location, LocationCategory, ListParams, PaginatedResponse } from '@/lib/api/types'

export interface WorldLocation {
    id: number
    city: string
    country: string
    lat: number | null
    lng: number | null
    displayName: string
}

export interface LocationMapData {
    lat: number | null
    lng: number | null
    description: string
    address1?: string
    address2?: string
    county?: string
    postcode?: string
    city: string
    country: string
    categoryName: string
    categoryDescription: string
}

export const locationsApi = {
    list: (params?: ListParams) =>
        api.get<PaginatedResponse<Location>>('/api/locations', { params }),

    get: (id: number) =>
        api.get<Location>(`/api/locations/${id}`),

    create: (data: Omit<Location, 'id'>) =>
        api.post<Location>('/api/locations', data),

    update: (id: number, data: Partial<Omit<Location, 'id'>>) =>
        api.put<Location>(`/api/locations/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/locations/${id}`),

    getCategories: () =>
        api.get<LocationCategory[]>('/api/locations/categories'),

    searchWorldLocations: (search: string, limit?: number) =>
        api.get<WorldLocation[]>('/api/locations/world-locations/search', { 
            params: { search, limit } 
        }),

    getWorldLocationById: (id: number) =>
        api.get<WorldLocation[]>('/api/locations/world-locations/search', { 
            params: { id } 
        }),

    getMapData: () =>
        api.get<LocationMapData[]>('/api/locations/map/data'),

    getMapApiKey: () =>
        api.get<{ apiKey: string }>('/api/locations/map/api-key'),
}

